import HomePage from "./home/HomePage";

export const routes = [
  {
    path: "/",
    exact: true,
    component: HomePage,
  },
];
